import { dbg, initIframe, isValidEvent, warn } from './shared/functions';
var validActions = ['session_read', 'session_write', 'session_remove', 'local_read', 'local_write', 'local_remove'];
var isValidStorageEvent = function (messageEvent) {
    if (!isValidEvent(messageEvent)) {
        return false;
    }
    if (!messageEvent.data.action) {
        return false;
    }
    if (validActions.indexOf(messageEvent.data.action) < 0) {
        warn('action [' + messageEvent.data.action + '] unknown');
        return false;
    }
    if (!messageEvent.data.key) {
        warn('no key in message');
        return false;
    }
    if (messageEvent.data.action.indexOf('_read') >= 0 && !messageEvent.data.messageId) {
        warn('no messageId in read event');
        return false;
    }
    if (messageEvent.data.action.indexOf('_write') >= 0 && !messageEvent.data.value) {
        warn('no value in write event');
        return false;
    }
    return true;
};
var handleStorageEvent = function (messageEvent) {
    var eventAction = messageEvent.data.action;
    var eventKey = messageEvent.data.key;
    var eventMessage;
    dbg('handle storage event: ' + messageEvent.data.action);
    if (eventAction.indexOf('_write') > 0) {
        if (typeof messageEvent.data.value === 'object') {
            try {
                eventMessage = JSON.stringify(messageEvent.data.value);
            }
            catch (e) {
                dbg('handle storage exception for write eventAction: ' + e);
                return;
            }
        }
        else {
            eventMessage = messageEvent.data.value;
        }
        if (eventAction.indexOf('local_') === 0) {
            try {
                window.localStorage.setItem(eventKey, eventMessage);
            }
            catch (e) {
                dbg('handle storage exception for write eventAction: ' + e);
            }
        }
        else if (eventAction.indexOf('session_') === 0) {
            try {
                window.sessionStorage.setItem(eventKey, eventMessage);
            }
            catch (e) {
                dbg('handle storage exception for write eventAction: ' + e);
            }
        }
    }
    if (eventAction.indexOf('_remove') > 0) {
        if (eventAction.indexOf('local_') === 0) {
            try {
                window.localStorage.removeItem(eventKey);
            }
            catch (e) {
                dbg('handle storage exception for write eventAction: ' + e);
            }
        }
        else if (eventAction.indexOf('session_') === 0) {
            try {
                window.sessionStorage.removeItem(eventKey);
            }
            catch (e) {
                dbg('handle storage exception for remove eventAction: ' + e);
            }
        }
    }
    if (eventAction.indexOf('_read') > 0) {
        var messageId = messageEvent.data.messageId;
        if (eventAction.indexOf('local_') === 0) {
            try {
                eventMessage = window.localStorage.getItem(eventKey) || '';
            }
            catch (e) {
                dbg('handle storage exception for read eventAction: ' + e);
                return;
            }
        }
        else if (eventAction.indexOf('session_') === 0) {
            try {
                eventMessage = window.sessionStorage.getItem(eventKey) || '';
            }
            catch (e) {
                dbg('handle storage exception for read eventAction: ' + e);
                return;
            }
        }
        parent.postMessage({ type: 'om storage message', messageId: messageId, value: eventMessage }, '*');
    }
};
var handleMessage = function (messageEvent) {
    if (isValidStorageEvent(messageEvent)) {
        handleStorageEvent(messageEvent);
    }
};
initIframe(handleMessage);
export { isValidStorageEvent };
//# sourceMappingURL=storage.js.map